import Styles from './ReferenceImageButton.module.scss'
import { forwardRef } from 'react'
import { AriaLabelingProps } from '@react-types/shared'
import { filterDOMProps, useObjectRef } from '@react-aria/utils'
import { useButton } from '@react-aria/button'
import { ReferenceImageButtonProps } from 'screens/Schedule/PostPromptsSection/Types'
import { Text } from 'blaze-ui/Text/Text'
import { Edit1 } from 'blaze-ui/icons'
import { ReferenceImg } from 'screens/Schedule/PostPromptsSection/ReferenceImg'

export const ReferenceImageButton = forwardRef<HTMLButtonElement, ReferenceImageButtonProps & AriaLabelingProps>(
  ({ referenceMediaFile, width = 178, height = 178, ...props }, fRef) => {
    const ref = useObjectRef(fRef)
    const { buttonProps } = useButton(props, ref)
    return (
      <button {...buttonProps} {...filterDOMProps(props, { labelable: true })} className={Styles.referenceImage}>
        <ReferenceImg src={referenceMediaFile.source_url || ''} alt="Reference Image" width={width} height={height} />
        <div className={Styles.label}>
          <Text color="var(--light-100)" lineClamp={1} variant="secondary">
            Reference Image
          </Text>
          <Edit1 color="var(--light-100)" size={15} />
        </div>
      </button>
    )
  },
)
